import { createContext } from 'react';
import { IDataGetUserInfo } from 'types';

export type TUserInfoVisibleForm = 'mainForm' | 'additionally';

export interface IUserProfileState {
	userForUserInfo: IDataGetUserInfo | null;
	userInfoVisibleForm: TUserInfoVisibleForm;
}

export const userProfileInitialState: IUserProfileState = {
	userForUserInfo: null,
	userInfoVisibleForm: 'mainForm',
};

export interface IUserProfileContext extends IUserProfileState {
	changeUserInfoVisibleForm(value: TUserInfoVisibleForm): void;
	setUserForUserInfo(value: IDataGetUserInfo): void;
}

export const UserProfileContext = createContext<IUserProfileContext>({
	changeUserInfoVisibleForm: () => undefined,
	setUserForUserInfo: () => undefined,
	...userProfileInitialState,
});
